import {
  b2cHttpClient,
  IRegistration,
  IUsProducerPresenter,
} from "madeinusacomponentlibrary";
import AuthProvider, { getAccessToken } from "../AuthProvider";
import configData from "../AppConfig.json";

export class APIClient {
  httpClient: b2cHttpClient = new b2cHttpClient(getAccessToken, configData);

  b2CUserId = AuthProvider.UserAgentApplication.getAccount().accountIdentifier;

  getStates = async () => {
    try {
      const response = await this.httpClient.getStates();
      if (response) {
        response?.forEach((x) => {
          x.key = x.name;
          x.text = x.abbreviation;
        });
        //console.log("getStates", response);
      } else {
        return [];
      }
      return response;
    } catch {
      return [];
    }
  };

  getCountries = async () => {
    try {
      const response = await this.httpClient.getCountries();

      if (response) {
        response?.forEach((x) => {
          x.key = x.name;
          x.text = x.name;
        });
        //console.log("getCountries", response);
      } else {
        return [];
      }
      return response;
    } catch {
      return [];
    }
  };

  getPreferencePrograms = async () => {
    try {
      const response = await this.httpClient.getPreferencePrograms();
      if (response) {
        response?.forEach((x) => {
          x.key = x.name;
          x.text = x.name;
        });
        // console.log("getPreferencePrograms", response);
      } else {
        return [];
      }
      return response;
    } catch {
      return [];
    }
  };

  getProducts = async () => {
    try {
      const response = await this.httpClient.getProducts();
      if (response) {
        //console.log("getProducts", response);
      } else {
        return [];
      }
      return response;
    } catch {
      return [];
    }
  };

  getRegions = async () => {
    try {
      const response = await this.httpClient.getRegions();
      if (response) {
        response?.forEach((x) => {
          x.key = x.name;
          x.text = x.name;
        });
        //console.log("getRegions", response);
      } else {
        return [];
      }
      return response;
    } catch {
      return [];
    }
  };

  createRegistration = async (data: IUsProducerPresenter) => {
    const response = await this.httpClient.createRegistration(data);
    return response;
  };

  updateRegistrationToDirectory = async (data: IUsProducerPresenter) => {
    const response = await this.httpClient.updateDirectory(data);
    return response;
  };
  getRegistration = async (b2CUserId: string) => {
    const response = await this.httpClient.getRegistration(b2CUserId);
    return response;
  };
  getRegistrationByEmail = async (Email: string) => {
    const response = await this.httpClient.getRegistrationByEmail(Email);
    return response;
  };

  getDirectoryEntry = async (b2CUserId: string) => {
    const response = await this.httpClient.getDirectoryEntry(b2CUserId);
    return response;
  };

  getDirectoryByEmail = async () => {
    const response = await this.httpClient.getDirectoryByEmail();
    return response;
  };

  removeRegistration = async (data: IRegistration) => {
    const response = await this.httpClient.removeRegistration(data);
    return response;
  };
}
